
const menuHighlight = () => {
  const menuHighlight = document.querySelector(".js-menu-highlight");
  if (!menuHighlight) return;

  // Intersection Observer のオプション
  const options = {
    root: null,
    rootMargin: "-60px 0px -66% 0px",
    threshold: 0
  };

  // メニュー内のすべてのリンクから監視対象のセクションを自動検出
  const sections = [];
  document.querySelectorAll(".js-menu-highlight a").forEach((link) => {
    const href = link.getAttribute("href");

    // href が "#id" 形式の場合、対応するセクション要素を取得
    if (href && href.startsWith("#")) {
      const sectionId = href.substring(1);
      const section = document.getElementById(sectionId);

      if (section) {
        sections.push({ section, link });
      }
    }
  });

  // セクション要素がない場合は処理を終了
  if (sections.length === 0) return;

  // Intersection Observer のコールバック
  const observer = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      const linkData = sections.find(item => item.section === entry.target);
      if (!linkData) return;

      if (entry.isIntersecting) {
        // すべてのリンクから data-active を削除
        document.querySelectorAll(".js-menu-highlight a").forEach((el) => {
          el.removeAttribute("data-active");
        });
        // 現在のセクションに対応するリンクに data-active を付与
        linkData.link.setAttribute("data-active", "");
      }
    });
  }, options);

  // セクション要素を監視
  sections.forEach(({ section }) => {
    observer.observe(section);
  });
};

const main = () => {
  menuHighlight();
};

export default main;
